import { createFileRoute } from "@tanstack/react-router";
import { StakingActivityPage } from "../../features/staking/pages/staking-activity-page";

export const Route = createFileRoute("/_layout/staking/activity")({
  component: StakingActivityPage,
});
